'use strict';

function AdjustDatesPanelDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'AdjustDatesPanelController',
    template: require('../templates/adjust-dates-panel.html'),
    scope: {
      recommendationEntry: '=',
      screenState: '='
    },
    link: function link($scope) {
      $scope.$on('aligned:fares', function (ev, recommendationEntry) {
        $timeout(function () {
          $scope.transformAdjustedDatesForAlign(recommendationEntry.data);
        }, 50);
      });
      $scope.$watch('recommendationEntry.data.showAdjustDates', function (isShowed) {
        if (!isShowed || !$scope.recommendationEntry && $scope.recommendationEntry.data) {
          $scope.onAdjustmentReady = false;
          return;
        }
        !!$scope.recommendationEntry.hostLadder.alignedWith ? $scope.transformAdjustedDatesForAlign($scope.recommendationEntry.data) : $scope.transformAdjustedDates($scope.recommendationEntry.data);
        $timeout(function () {
          $scope.onAdjustmentReady = true;
        }, 50);
      });
      $scope.$watch('screenState.recommendChartMode', function (recommendMode, oldRecommendMode) {
        if (recommendMode && recommendMode !== oldRecommendMode && $scope.recommendationEntry.data.showAdjustDates) {
          $scope.onAdjustmentReady = false;
          $scope.resetAdjustments();
          $scope.recommendationEntry.data.showAdjustDates = false;
        }
      });
    }
  };
}
AdjustDatesPanelDirective.$inject = ['$timeout'];
module.exports = AdjustDatesPanelDirective;